<div class="head" (click)="opened = !opened">
  <div class="title">{{title}}</div>
  <img src="assets/img/plus-white.svg" alt="plus" [ngClass]="{'active': !opened}">
  <img src="assets/img/minus-white.svg" alt="minus" [ngClass]="{'active': opened}">
</div>
<div class="content" [ngClass]="{'active': opened}">{{text}}</div>
